/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/case-practice-hotel-component/case-practice-messagebox.component.css.shim.ngstyle.js.pre-build-optimizer.js